import { OfferType, ReplacementOffer } from '@dgx-pr-spa/shared/util';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filterDataByOfferType',
})
export class FilterDataByOfferTypePipe implements PipeTransform {
  transform(
    offers: ReplacementOffer[],
    offerType: OfferType
  ): ReplacementOffer[] {
    return offers.filter(({ offer_type }) => offer_type === offerType);
  }
}
